'use client'

import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { Calendar as CalendarIcon } from 'lucide-react'
import { useState } from 'react'

import { cn } from '@/lib/cn'

import { Button } from '../button'
import { Calendar } from '../calendar'
import { Popover, PopoverContent, PopoverTrigger } from '../popover'

type DatePickerProps = {
  date?: Date
  isError?: boolean
  disabled?: boolean
  label?: string
  className?: string
  onSelect?: (date?: Date) => void
  placeholder?: string
}

const DatePicker = ({
  date,
  isError,
  disabled,
  label,
  className,
  onSelect,
}: DatePickerProps) => {
  const [open, setOpen] = useState(false)

  const handleSelect = (selectedDate?: Date) => {
    if (date && selectedDate && date.getTime() === selectedDate.getTime()) {
      onSelect?.(undefined)
    } else {
      onSelect?.(selectedDate)
    }
    setOpen(false)
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="secondary"
          disabled={disabled}
          className={cn(
            'w-full justify-start text-left gap-2 border-system-border-primary font-normal text-system-text-primary bg-transparent hover:bg-white',
            !date && 'text-system-text-secondary',
            isError && 'border-system-state-error',
            className,
          )}
        >
          <CalendarIcon className="size-4" />
          {date ? (
            format(date, 'PPP', { locale: ptBR })
          ) : label ? (
            <span>{label}</span>
          ) : null}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={date}
          onSelect={handleSelect}
          defaultMonth={date}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  )
}
DatePicker.displayName = 'DatePicker'

export { DatePicker }
